export default __webpack_public_path__ + "static/media/shuffle-cards.5c11ee1a.mp3";